var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgForgotPasswordImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 547.729,
    height: 559.207,
    viewBox: "0 0 547.729 559.207",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#575a89}.prefix__cls-2{fill:#3f3d56}.prefix__cls-3{fill:#9aaeff}.prefix__cls-4{fill:#fff}.prefix__cls-5{fill:#bdb2fc}.prefix__cls-6{fill:#ffb9b9}.prefix__cls-7{fill:#2f2e41}.prefix__cls-8{opacity:.1}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1006",
    "data-name": "Group 1006",
    transform: "translate(-439 -276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6431",
    d: "M268.8 629.09l-6.117-24.128a313.323 313.323 0 0 0-33.24-11.926l-.772 11.213-3.133-12.349c-14.008-4-23.538-5.762-23.538-5.762s12.873 48.951 39.872 86.374l31.46 5.526-24.44 3.524a126.774 126.774 0 0 0 10.933 11.586c39.276 36.457 83.023 53.184 97.711 37.36s-5.245-58.205-44.522-94.662c-12.176-11.3-27.472-20.372-42.783-27.51z",
    className: "prefix__cls-1",
    "data-name": "Path 6431",
    transform: "translate(237 28.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6432",
    d: "M362.724 578.162l7.235-23.817a313.293 313.293 0 0 0-22.291-27.391l-6.457 9.2 3.7-12.194c-9.924-10.665-17.171-17.1-17.171-17.1s-14.283 48.558-10.515 94.55L341.3 622.4l-22.744-9.617a126.759 126.759 0 0 0 3.37 15.569c14.778 51.511 43.581 88.442 64.333 82.488s25.6-52.538 10.818-104.048c-4.581-15.969-12.987-31.639-22.4-45.664z",
    className: "prefix__cls-1",
    "data-name": "Path 6432",
    transform: "translate(201.258 53.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6433",
    d: "M876.605 742.366l4.552-4.916a84.311 84.311 0 0 0-2.177-9.253l-2.645 1.468 2.331-2.517c-1.149-3.749-2.147-6.159-2.147-6.159s-9.167 10.078-13.662 21.658l3.361 7.914-4.376-5a34.124 34.124 0 0 0-1.014 4.166c-2.478 14.21.154 26.539 5.879 27.537s12.375-9.712 14.853-23.922a44.924 44.924 0 0 0-.056-13.691z",
    className: "prefix__cls-1",
    "data-name": "Path 6433",
    transform: "translate(31.804 -13.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6434",
    d: "M969.237 757.87l6.438-1.856a84.33 84.33 0 0 0 2.919-9.046l-3.023-.11 3.3-.95c.954-3.8 1.345-6.383 1.345-6.383s-13.06 3.889-22.894 11.475l-1.213 8.512-1.161-6.545a34.119 34.119 0 0 0-3.022 3.042c-9.466 10.884-13.586 22.8-9.2 26.612s15.613-1.917 25.08-12.8a44.92 44.92 0 0 0 7.029-11.749z",
    className: "prefix__cls-1",
    "data-name": "Path 6434",
    transform: "translate(6.516 -19.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6435",
    d: "M616.168 127.344v421.231a33.235 33.235 0 0 1-33.223 33.23h-163.7A33.24 33.24 0 0 1 386 548.571V127.344a33.239 33.239 0 0 1 33.243-33.23H439.1a15.8 15.8 0 0 0 14.62 21.756h93.328a15.8 15.8 0 0 0 14.619-21.756h21.271a33.235 33.235 0 0 1 33.229 33.223z",
    className: "prefix__cls-2",
    "data-name": "Path 6435",
    transform: "translate(180 181.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_1797",
    width: 51.821,
    height: 21.656,
    className: "prefix__cls-3",
    "data-name": "Rectangle 1797",
    rx: 4,
    transform: "translate(702.426 595.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1798",
    d: "M0 0H547.182V1.376H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 1798",
    transform: "translate(439.547 763.016)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1005",
    "data-name": "Group 1005",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6438",
    d: "M574.055 375.729h-95.816a3.445 3.445 0 0 1-3.44-3.44v-95.817a3.445 3.445 0 0 1 3.44-3.44h95.816a3.445 3.445 0 0 1 3.441 3.44v95.816a3.445 3.445 0 0 1-3.441 3.441zm-95.816-101.321a2.067 2.067 0 0 0-2.064 2.064v95.816a2.066 2.066 0 0 0 2.064 2.064h95.816a2.067 2.067 0 0 0 2.064-2.064v-95.816a2.067 2.067 0 0 0-2.064-2.064z",
    className: "prefix__cls-4",
    "data-name": "Path 6438",
    transform: "translate(152.201 125.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8266",
    d: "M338.865 327.38a43.085 43.085 0 1 0 43.085 43.085 43.085 43.085 0 0 0-43.085-43.085zm7.725 44.12v20.4h-15.232v-20.4a12.621 12.621 0 1 1 15.232 0z",
    className: "prefix__cls-3",
    "data-name": "Path 8266",
    transform: "translate(339.22 79.62)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8235",
    d: "M559.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L552.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 0 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8235",
    transform: "translate(67.561 138.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8236",
    d: "M580.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L573.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 0 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8236",
    transform: "translate(58.1 138.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8237",
    d: "M601.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L594.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 0 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8237",
    transform: "translate(48.64 138.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8238",
    d: "M622.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L615.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 1 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8238",
    transform: "translate(39.179 138.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8239",
    d: "M643.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L636.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 0 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8239",
    transform: "translate(29.718 138.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8240",
    d: "M664.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L657.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 0 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8240",
    transform: "translate(20.258 138.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8241",
    d: "M685.748 426.726h-3.182l2.83-2.824a.28.28 0 0 0 0-.39.275.275 0 0 0-.39 0l-2.83 2.83v-3.187a.275.275 0 0 0-.275-.275.28.28 0 0 0-.275.275v3.187L678.8 423.5a.275.275 0 0 0-.39 0 .28.28 0 0 0 0 .39l2.83 2.824h-3.187a.28.28 0 0 0-.275.275.275.275 0 0 0 .275.275h3.187l-2.83 2.83a.28.28 0 0 0 0 .39.286.286 0 0 0 .39 0l2.824-2.83v3.182a.275.275 0 0 0 .549 0v-3.186l2.83 2.83a.286.286 0 0 0 .39 0 .28.28 0 0 0 0-.39l-2.83-2.83h3.182a.267.267 0 1 0 0-.533z",
    className: "prefix__cls-5",
    "data-name": "Path 8241",
    transform: "translate(10.797 138.426)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_688",
    "data-name": "Group 688",
    transform: "translate(-639.746 48.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6803",
    d: "M852.537 510.77s-11.9 24.8-3.967 25.789 9.919-22.317 9.919-22.317z",
    className: "prefix__cls-6",
    "data-name": "Path 6803",
    transform: "translate(581.123 71.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6804",
    d: "M800.483 654.464l-7.935 14.062 14.382 9 3.434-16.6z",
    className: "prefix__cls-6",
    "data-name": "Path 6804",
    transform: "translate(678.308 86.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6805",
    d: "M898.7 764.047s-4.357-7.094-5.933-5.906-8.076 6.332-8.076 6.332l-8.466 8.109s-28.6 3.024-10.428 13.047 28.22 1.712 28.22 1.712 25.457 1.324 25.046-5.779-8.621-18.339-8.621-18.339-10.348 6.938-11.742.824z",
    className: "prefix__cls-7",
    "data-name": "Path 6805",
    transform: "translate(576.705 -7.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6806",
    d: "M898.7 764.047s-4.357-7.094-5.933-5.906-8.076 6.332-8.076 6.332l-8.466 8.109s-28.6 3.024-10.428 13.047 28.22 1.712 28.22 1.712 25.457 1.324 25.046-5.779-8.621-18.339-8.621-18.339-10.348 6.938-11.742.824z",
    className: "prefix__cls-8",
    "data-name": "Path 6806",
    transform: "translate(576.705 -7.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6807",
    d: "M953.363 504.978l-7.439 90.013s-.248 53.809-8.183 64.224-8.183 15.622-8.183 15.622l-16.366-8.431s5.455-.5 2.976-3.968-9.919 0-2.976-4.959 8.431-5.122 6.7-7.272a11.983 11.983 0 0 1-2.232-4.63l4.463-55.545-8.431-96.708z",
    className: "prefix__cls-7",
    "data-name": "Path 6807",
    transform: "translate(560.641 76.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6808",
    d: "M953.363 504.978l-7.439 90.013s-.248 53.809-8.183 64.224-8.183 15.622-8.183 15.622l-16.366-8.431s5.455-.5 2.976-3.968-9.919 0-2.976-4.959 8.431-5.122 6.7-7.272a11.983 11.983 0 0 1-2.232-4.63l4.463-55.545-8.431-96.708z",
    className: "prefix__cls-8",
    "data-name": "Path 6808",
    transform: "translate(560.641 76.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6810",
    d: "M825.986 653.54l6.943 18.35 19.838-7.439-12.4-12.894z",
    className: "prefix__cls-6",
    "data-name": "Path 6810",
    transform: "translate(667.684 87.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6811",
    d: "M944.243 755.8s-7.413-4.633-8.339-2.78-4.633 9.729-4.633 9.729l-4.17 11.582s-25.481 16.215-3.706 17.141 27.334-11.582 27.334-11.582 24.554-10.656 20.848-17.141-16.677-13.211-16.677-13.211-6.488 11.362-10.657 6.262z",
    className: "prefix__cls-7",
    "data-name": "Path 6811",
    transform: "translate(559.277 -4.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6812",
    d: "M879.25 509.615l-3.968 82.822s19.341 55.049 36.2 63.976c0 0 0 10.911 3.968 12.894a9.959 9.959 0 0 1 4.959 5.951l21.821-5.455s-5.455-5.455-3.472-7.935-6.447-7.935-6.447-7.935l-21.821-53.065s-3.471-1.488-4.463-6.447-2.976-4.959 1.984-5.951a6.16 6.16 0 0 0 4.959-5.951l16.366-75.383z",
    className: "prefix__cls-7",
    "data-name": "Path 6812",
    transform: "translate(571.768 72.492)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3789",
    cx: 19.838,
    cy: 19.838,
    r: 19.838,
    className: "prefix__cls-6",
    "data-name": "Ellipse 3789",
    transform: "translate(1449.035 412.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6813",
    d: "M924.95 293.056s1.488 25.293 3.472 27.773-20.829 1.984-20.829 1.984 1.488-21.325 0-23.309 17.357-6.448 17.357-6.448z",
    className: "prefix__cls-6",
    "data-name": "Path 6813",
    transform: "translate(561.529 140.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6814",
    d: "M922.56 322.349s-18.846-1.984-25.789 3.968a51.031 51.031 0 0 1-7.1 5.081 14.567 14.567 0 0 0-7.068 12.061l-3.683 112.793s56.041-4.959 66.456 0c0 0 .5-11.407 1.488-12.894.723-1.085 1.973-44.34 2.6-67.7a51.446 51.446 0 0 0-13.021-35.906c-3.006-3.327-6.364-6.116-9.91-7.48-.006-.004.986-9.427-3.973-9.923z",
    className: "prefix__cls-1",
    "data-name": "Path 6814",
    transform: "translate(570.614 131.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6815",
    d: "M883.068 336.974A14.649 14.649 0 0 0 872.29 349.1l-7.075 50.36-9.915 40.173s-4.959 4.463-2.976 6.943-2.48 12.894-2.48 12.894l12.4 3.967s1.488-10.415 3.967-10.911c2.179-.436 26.574-65.6 32.454-81.391.811-2.177 1.27-3.415 1.27-3.415s-.997-33.226-16.867-30.746z",
    className: "prefix__cls-1",
    "data-name": "Path 6815",
    transform: "translate(579.853 126.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6816",
    d: "M908.921 381.741l-30 81.17s29.009-54.885 30-81.17z",
    className: "prefix__cls-8",
    "data-name": "Path 6816",
    transform: "translate(570.614 112.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6817",
    d: "M905.007 283a26.413 26.413 0 0 0-4.982.688 12.609 12.609 0 0 1-13.477-9.4 7.21 7.21 0 0 0-.689-2.246c-.917-1.5-3.006-1.783-4.729-1.439s-3.355 1.15-5.109 1.243a7.823 7.823 0 0 1-6.751-3.821 12.956 12.956 0 0 1-1.657-7.826l1.3 1.363a6.594 6.594 0 0 0 .588-3.584 4.158 4.158 0 0 1 3.939 1.008c1.145.122.281-2.123 1.131-2.9a1.967 1.967 0 0 1 1.384-.259c2.435.023 4.405-1.839 6.324-3.339a26.876 26.876 0 0 1 11.351-5.178 14.933 14.933 0 0 1 8.282.4 17.688 17.688 0 0 1 5.593 3.967c4.083 3.926 7.7 8.539 9.4 13.943a23.472 23.472 0 0 1 .112 13.61c-.684 2.31-2.747 10.222-5.767 10.406-3.798.236-1.52-6.352-6.243-6.636z",
    className: "prefix__cls-7",
    "data-name": "Path 6817",
    transform: "translate(574.229 155.177)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1795",
    d: "M0 0H125.954V1.376H0z",
    className: "prefix__cls-4",
    "data-name": "Rectangle 1795",
    transform: "translate(618 576.056)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgForgotPasswordImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/forgotPasswordImage.337c586054c98e2dced5f244d924ef30.svg";